<template>
  <div id="atendimentos-no-mes">
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Relatório atendimentos"
            description="Atendimentos, procedimentos, vacinas ou visitas realizados nos últimos 90 dias"
            url="/dashboard"
          />
        </div>
        <div class="col-lg-4 col-md-12">
          <div class="form-group">
            <label for="">Data inicial</label>
            <input type="date" class="form-control" v-model="periodoInicial" />
          </div>
        </div>
        <div class="col-lg-4 col-md-12">
          <div class="form-group">
            <label for="">Data final</label>
            <input type="date" class="form-control" v-model="periodoFinal" />
          </div>
        </div>
        <div class="col-lg-4 col-md-12">
          <div class="form-group">
            <button
              class="btn btn-filter"
              type="button"
              :disabled="loadingBtn"
              @click="buscarDados"
            >
              Buscar
              <b-spinner
                label="Spinning"
                small
                variant="white"
                v-if="loadingBtn"
              ></b-spinner>
            </button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="info-table">
            <div class="info-table-item">
              <div class="filter-select">
                <vue-select
                  :options="estabelecimentos"
                  label="no_unidade_saude"
                  placeholder="Unidade de saúde"
                  @input="onChangeEstabelecimento"
                  v-model="selectedEstabelecimento"
                  :loading="loadingSelects"
                  :disabled="cadastros.length == 0"
                >
                  <template slot="option" slot-scope="option">
                    {{ option.no_unidade_saude }}
                  </template>
                  <div slot="no-options">Não há opções correspondentes</div>
                </vue-select>
                <vue-select
                  :options="equipes"
                  label="no_equipe"
                  placeholder="Equipes"
                  @input="onChangeEquipe"
                  v-model="selectedEquipe"
                  :loading="loadingSelects"
                  :disabled="cadastros.length == 0"
                >
                  <template slot="option" slot-scope="option">
                    {{ option.no_equipe }}
                  </template>
                  <div slot="no-options">Não há opções correspondentes</div>
                </vue-select>
              </div>
            </div>
          </div>
          <TabelaCadastros
            :cadastros="cadastros"
            :loading="loading"
            :dataInicial="periodoInicial"
            :dataFinal="periodoFinal"
          />
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from './SectionTitle'
import utils from '@/mixins/utils.js'
import ModalInfo from './ModalInfo'
import TabelaCadastros from './TabelaCadastros.vue'

export default {
  name: 'AtendimentosNoMes',
  metaInfo: {
    title: 'Relatório atendimentos',
    titleTemplate: null,
  },
  components: {
    Menu,
    Footer,
    SectionTitle,
    ModalInfo,
    TabelaCadastros,
  },
  mixins: [utils],
  computed: {},
  data() {
    return {
      periodoInicial: '',
      periodoFinal: '',
      equipes: [],
      equipe: '',
      cadastrosOriginais: [],
      cadastros: [],
      loading: false,
      selectedEquipe: '',
      estabelecimentos: [],
      loadingSelects: false,
      selectedEstabelecimento: '',
      loadingBtn: false,
    }
  },
  methods: {
    /**
     * Manipula a alteração do estabelecimento selecionado.
     *
     * @param {Object} item Equipe selecionada
     */
    async onChangeEstabelecimento(item) {
      this.selectedEquipe = null
      if (item == null) {
        this.cadastros = this.cadastrosOriginais
        return
      }
      this.cadastros = this.cadastrosOriginais.filter((el) => {
        return el.co_ubs != null && el.co_ubs == item.co_ubs
      })
    },

    /**
     * Manipula a alteração da equipe selecionada.
     *
     * @param {Object} equipe Equipe selecionada
     */
    async onChangeEquipe(equipe) {
      this.selectedEstabelecimento = null
      if (equipe == null) {
        this.cadastros = this.cadastrosOriginais
        return
      }
      this.cadastros = this.cadastrosOriginais.filter((item) => {
        return item.co_equipe != null && item.co_equipe == equipe.co_equipe
      })
    },

    /**
     * Buscar os dados
     * */
    async buscarDados() {
      try {
        if (this.periodoInicial === '' && this.periodoFinal === '') {
          this.$toast.error(
            'Selecione uma data de início e de fim!',
            'Error:',
            {
              position: 'topRight',
            }
          )
          return false
        }

        if (new Date(this.periodoInicial) > new Date(this.periodoFinal)) {
          this.$toast.error(
            'O período inicial não pode ser maior do que o período final!',
            'Error:',
            {
              position: 'topRight',
            }
          )
          return false
        }

        this.loading = true
        this.loadingBtn = true

        this.selectedEstabelecimento = null
        this.selectedEquipe = null
        this.cadastrosOriginais = []
        this.cadastros = []

        const inicio = this.periodoInicial.replaceAll('-', '')
        const fim = this.periodoFinal.replaceAll('-', '')

        let response = await this.$api.get(
          `/app/relatorio-atendimentos/${this.$store.state.cod_ibge}/${inicio}/${fim}`
        )
        if (response) {
          this.cadastrosOriginais = response.data
          this.cadastros = response.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
        this.loadingBtn = false
      }
    },

    /**
     * Carrega os selects das unidades de saúde e equipes
     */
    async carregarSelects() {
      try {
        this.loadingSelects = true
        let response = await this.$api.get(
          `/app/relatorio-atendimentos/${this.$store.state.cod_ibge}/unidades-de-saude`
        )
        if (response) {
          this.estabelecimentos = response.data
        }

        let response2 = await this.$api.get(
          `/app/relatorio-atendimentos/${this.$store.state.cod_ibge}/equipes`
        )
        if (response2) {
          this.equipes = response2.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingSelects = false
      }
    },

    /**
     * Carrega as datas do período final e inicial
     */
    carregarDatas() {
      const hoje = new Date()
      const menos90 = new Date()
      menos90.setDate(menos90.getDate() - 90)

      const formatar = (d) => {
        const ano = d.getFullYear()
        const mes = String(d.getMonth() + 1).padStart(2, '0')
        const dia = String(d.getDate()).padStart(2, '0')
        return `${ano}-${mes}-${dia}`
      }

      this.periodoFinal = formatar(hoje)
      this.periodoInicial = formatar(menos90)
    },
  },
  created() {
    this.carregarDatas()
    this.carregarSelects()
  },
}
</script>

<style lang="scss" scoped>
#atendimentos-no-mes {
  .btn-filter {
    margin-top: 30px;
  }
  .filter-select {
    margin: 0;
  }
}
</style>

<style scoped>
#atendimentos-no-mes .v-select {
  min-width: 300px;
}
@media screen and (max-width: 656px) {
  #atendimentos-no-mes .v-select {
    width: 100%;
  }
}
</style>
